/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';

import Button from 'shared-components/Button/Button';
import PreviewProductCard from '../PreviewProductCard/PreviewProductCard';
import styles from './PreviewProductsDesktop.module.css';

const PreviewProductsDesktop = ({
  title,
  subtitle,
  products,
  buttonAction,
  buttonText,
}) => {
  return (
    <div className={styles.container}>
      <h2>{title}</h2>
      <p>{subtitle}</p>
      <div className={styles.productsContainer}>
        {map(products, (product, index) => (
          <div className={styles.productContainer} key={index}>
            <PreviewProductCard {...product} isMobileDevice={false} />
          </div>
        ))}
      </div>
      <Button onClick={buttonAction}>{buttonText}</Button>
    </div>
  );
};

PreviewProductsDesktop.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      brandName: PropTypes.string,
      name: PropTypes.string.isRequired,
      salePrice: PropTypes.string,
      price: PropTypes.string,
      imageUrl: PropTypes.string.isRequired,
      percentOff: PropTypes.number.isRequired,
    })
  ).isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonAction: PropTypes.func.isRequired,
};

export default PreviewProductsDesktop;
